import { TZDate } from "@toast-ui/calendar"
import { hostName, testHostName } from "./constants"
import { useAppNotificationStore } from "stores"

export function clone(date: TZDate): TZDate {
  return new TZDate(date)
}

export function addHours(d: TZDate, step: number) {
  const date = clone(d)
  date.setHours(d.getHours() + step)

  return date
}

export function addDate(d: TZDate, step: number) {
  const date = clone(d)
  date.setDate(d.getDate() + step)

  return date
}

export function subtractDate(d: TZDate, steps: number) {
  const date = clone(d)
  date.setDate(d.getDate() - steps)

  return date
}

export function isPadeDomain() {
  const host_name = window.location.hostname

  if (
    host_name == hostName ||
    host_name == testHostName ||
    host_name === "localhost"
  ) {
    return true
  } else {
    return false
  }
}
export const isLocalOrDevOrStaging = () => {
  const host_name = window.location.hostname

  if (
    host_name === "white-stone-0f6021d10.2.azurestaticapps.net" ||
    host_name === "staging.paidhr.com" ||
    host_name === "localhost"
  ) {
    return true
  } else {
    return false
  }
}
export const isLocalOrDev = () => {
  const host_name = window.location.hostname

  if (
    host_name === "white-stone-0f6021d10.2.azurestaticapps.net" ||
    host_name === "localhost"
  ) {
    return true
  } else {
    return false
  }
}

export const getRelativePathFromUrl = (url: string) => {
  try {
    const normalized = /^https?:\/\//i.test(url) ? url : `https://${url}`
    const parsedUrl = new URL(normalized)
    // Drop the incoming host (e.g. staging.paidhr.com) and rebuild the URL
    // on the host the app is currently running on.
    return (
      window.location.origin +
      parsedUrl.pathname +
      parsedUrl.search +
      parsedUrl.hash
    )
  } catch (error) {
    // If the URL is invalid, return it as is (or handle the error as needed)
    console.error("Invalid URL:", url)
    return url
  }
}

export const isDevelopment = process.env.NODE_ENV === "development"

export const removeNullOrUndefined = (obj: any): any => {
  Object.keys(obj).forEach((key) => {
    if (!obj[key]) {
      delete obj[key]
    }
  })

  return obj
}

export const unescapedContent = (escapedContent: string): any =>
  new DOMParser().parseFromString(escapedContent, "text/html").documentElement
    .textContent

export const onQueryError = (err: any) => {
  useAppNotificationStore
    .getState()
    .toast.error(
      err?.response?.data?.message ||
        err?.response?.message ||
        err?.message ||
        "Something went wrong."
    )
}

/**
 * Converts camelCase or PascalCase strings into
 * human-readable labels while preserving acronyms.
 *
 * Examples:
 *  - "AllEmployees"     → "All Employees"
 *  - "HRManager"        → "HR Manager"
 *  - "userIDNumber"     → "User ID Number"
 */
export function toReadableLabel(value: string): string {
  // Return early if the value is empty or undefined
  if (!value) return value

  return (
    value
      // Split acronyms followed by a regular word
      // Example: "HRManager" → "HR Manager"
      .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")

      // Split camelCase or PascalCase words
      // Example: "reportingManager" → "reporting Manager"
      //          "AllEmployees" → "All Employees"
      .replace(/([a-z])([A-Z])/g, "$1 $2")

      // Capitalize the first character of the final label
      .replace(/^./, (char) => char.toUpperCase())
  )
}

export const getSidenavBadgeColor = (
  badge: "New" | "Legacy" | "Coming Soon" | string
): string => {
  switch (badge) {
    case "New":
      return "teal"
    case "Legacy":
      return "orange"
    case "Coming Soon":
      return "blue"
    default:
      return "blue"
  }
}
